import { render, staticRenderFns } from "./TagihanExtBelumLunas.vue?vue&type=template&id=dfa20f54&scoped=true&"
import script from "./TagihanExtBelumLunas.vue?vue&type=script&lang=js&"
export * from "./TagihanExtBelumLunas.vue?vue&type=script&lang=js&"
import style0 from "./TagihanExtBelumLunas.vue?vue&type=style&index=0&id=dfa20f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa20f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VContainer,VDataTable})
